import React, { useState } from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import { Icon, CloseIcon, C } from "./staffingUi";
import { IconButton } from "./SlotCell";

/** The "⋮" menu on a session row: add an opening of a role, or close sign-ups while the session is open to instructors. */
export default function SessionMenu({ label, roles, posted, onAdd, onClose }) {
  const [anchor, setAnchor] = useState(null);
  const dismiss = () => setAnchor(null);
  return (
    <>
      <IconButton label={`Session actions for ${label}`} onClick={(e) => setAnchor(e.currentTarget)}
        sx={{ width: 36, height: 36, borderRadius: "8px" }}>
        <Icon size={16}><circle cx="12" cy="5" r="1" /><circle cx="12" cy="12" r="1" /><circle cx="12" cy="19" r="1" /></Icon>
      </IconButton>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={dismiss}>
        {roles.map((r) => (
          <MenuItem key={r.value} dense onClick={() => { dismiss(); onAdd(r.value); }}>
            <Icon><path d="M12 5v14M5 12h14" /></Icon>
            <Box component="span" sx={{ ml: 1 }}>Add {r.label.toLowerCase()} opening</Box>
          </MenuItem>
        ))}
        {posted && (
          <MenuItem dense onClick={() => { dismiss(); onClose(); }} sx={{ color: C.danger, borderTop: `1px solid ${C.line}`, mt: "4px" }}>
            <CloseIcon />
            <Box component="span" sx={{ ml: 1 }}>Close sign-ups</Box>
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
